<form fxLayout="column" (ngSubmit)="save()" *ngIf="profile">
  <div fxLayout="row">
    <div fxLayout="column" fxFlex>
      <mat-form-field appearance="outline">
        <mat-label>Id</mat-label>
        <mat-icon matPrefix>label_important</mat-icon>
        <input
          name="profile_handle"
          matInput
          [(ngModel)]="profile.handle"
          type="text"
          required
          [readonly]="!isAdmin()"
        />
        <mat-icon matSuffix *ngIf="oldHandle && oldHandle != profile.handle"
          >warning</mat-icon
        >
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email principale</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input
          name="user_email"
          matInput
          [(ngModel)]="user.email"
          type="email"
          required
          readonly
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nome e Cognome</mat-label>
        <mat-icon matPrefix>person</mat-icon>
        <input
          name="profile_displayName"
          matInput
          [(ngModel)]="profile.displayName"
          type="text"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Numero di telefono</mat-label>
        <mat-icon matPrefix>phone</mat-icon>
        <input
          name="profile_phoneNumber"
          matInput
          [(ngModel)]="profile.phoneNumber"
          type="text"
          required
        />
      </mat-form-field>
    </div>
    <div fxLayout="row">
      <span>&nbsp;&nbsp;</span>
      <app-user-profile-image-form-field
        [(imageUrl)]="profile.photoUrl"
        [userId]="user.id"
        [label]="'Foto profilo *'"
      ></app-user-profile-image-form-field>
    </div>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Nome blog / agenzia</mat-label>
    <mat-icon matPrefix>business</mat-icon>
    <input
      name="profile_agency"
      matInput
      [(ngModel)]="profile.agency"
      type="text"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="mat-form-field-textarea-fix">
    <mat-label>Bio</mat-label>
    <mat-icon matPrefix>format_align_left</mat-icon>
    <textarea
      rows="4"
      name="profile_bio"
      matInput
      [(ngModel)]="profile.bio"
      required
    ></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>URL Sito Web</mat-label>
    <mat-icon matPrefix>link</mat-icon>
    <input
      name="profile_websiteUrl"
      matInput
      [(ngModel)]="profile.websiteUrl"
      type="url"
    />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>URL profilo Instagram</mat-label>
    <mat-icon matPrefix>link</mat-icon>
    <input
      name="profile_instagramUrl"
      matInput
      [(ngModel)]="profile.instagramUrl"
      type="url"
    />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>URL profilo Facebook</mat-label>
    <mat-icon matPrefix>link</mat-icon>
    <input
      name="profile_facebookUrl"
      matInput
      [(ngModel)]="profile.facebookUrl"
      type="url"
    />
  </mat-form-field>

  <p style="text-align: center">
    <button mat-raised-button color="primary" type="submit">Salva</button>
  </p>
</form>
